export class WorkChecksRequest {

    _constructionId;
    _year;
    _month;
    _companyId;
    _term;
    _page;
    _includeDocuments;

    constructor() {
        this._constructionId = undefined;
        this._year = undefined;
        this._month = undefined;
        this._companyId = undefined;
        this._term = undefined;
        this._page = 1;
        this._includeDocuments = undefined;
    }

    setConstructionId(constructionId) {
        this._constructionId = constructionId;
    }

    setYear(year) {
        this._year = year;
    }

    setMonth(month) {
        this._month = month;
    }

    setCompanyId(companyId) {
        this._companyId = companyId;
    }

    setTerm(term) {
        this._term = term;
    }

    setPage(page) {
        this._page = page;
    }

    setIncludeDocuments(includeDocuments) {
        this._includeDocuments = includeDocuments;
    }

    body() {
        const criteria = {};
        if ( this._constructionId ) criteria.construction_id = this._constructionId;
        if ( this._year ) criteria.year = this._year;
        if ( this._month ) criteria.month = this._month;
        if ( this._companyId ) criteria.company_id = this._companyId;
        if ( this._term ) criteria.term = this._term;
        if ( this._page ) criteria.page = this._page;
        if ( this._includeDocuments ) criteria.include_documents = this._includeDocuments;
        return { criteria };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/work-checks/work-checks-list/WorkChecksRequest.js